var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "news-filter primary-text primary-border d-flex flex-row align-items-center"
        },
        [
          _c(
            "button",
            {
              staticClass: "news-filter__button primary-text primary-border",
              attrs: { "aria-haspopup": "dialog" },
              on: {
                click: function($event) {
                  _vm.open = true
                }
              }
            },
            [
              _c("span", {
                staticClass: "mr-2",
                domProps: { innerHTML: _vm._s(_vm.icon) }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.buttonLabel))])
            ]
          ),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.valuesPresentation,
                expression: "valuesPresentation"
              }
            ],
            staticClass: "news-filter__long-dash primary-background"
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "news-filter__selected-category primary-text" },
            [_vm._v(_vm._s(_vm.valuesPresentation))]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "container-fluid w-100 h-100 d-flex flex-column align-items-stretch justify-content-center"
            },
            [
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.options, function(option, idx) {
                  return _c("news-select", {
                    key: idx.toString(),
                    staticClass: "news-filter__select",
                    attrs: {
                      options: option,
                      label: _vm.labels[idx],
                      value: _vm.values[idx]
                    },
                    on: {
                      select: function($event) {
                        return _vm.select($event, idx)
                      }
                    }
                  })
                }),
                1
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }